<template>
  <div class="sports">
    <div class="sports_top">
      <div class="sports_top_left">
        <el-carousel indicator-position="outside">
          <el-carousel-item >
            <img style="width:100%;height:100%" :src="companyInfo&&companyInfo.carouselImage?'https://www.htsd.vip'+companyInfo.carouselImage:require('../assets/images/fr1198x430_2.png')" alt />
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
    <div class="sports_bottom">
      <div class="sports_bottom_top">
        <div>
          <i class="el-icon-s-platform"></i> <span>公司简介</span>
        </div>
      </div>
      <div class="intro">
        <div class='intro_in'>
          <div class="textTop">
            公司简介：{{companyInfo&&companyInfo.companyProfile }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import headComponent from "../components/headComponent.vue";

export default {
  name: "home",
  components: {
    headComponent
  },
  computed: {
    ...mapState(['companyInfo'])
  }
}
</script>
<style  lang="less" >
.sports {
  margin: 0 auto;
  margin-top: 30px;
  width: 1198px;
  height: 1092px;
  .sports_top {
    width: 100%;
    height: 430px;
    // background-color: #969696;
    .sports_top_left {
      float: left;
      position: relative;
      width: 100%;
      height: 100%;
      background-color: #558589;
      .el-carousel__indicators, .el-carousel__indicators--horizontal, .el-carousel__indicators--outside{
        // position: absolute;
        left: 35%;
        bottom: 0;
      }
      /deep/.el-carousel__container{
        height: 430px;
      }
      .el-carousel__container{
        height: 430px!important;
      }
      
    }
    .sports_top_right {
      float: right;
      width: 420px;
      height: 420px;
      // background-color: #232332;
      .sports_top_right_title {
        height: 59px;
        width: 100%;
        border-bottom: 1px solid #e5e5e5;
        .sports_top_right_title_left {
          display: inline-block;
          box-sizing: border-box;
          // padding-left: 20px;
          text-align: center;
          height: 59px;
          line-height: 59px;
          width: 111px;
          color: #25b1f7;
          border-top: 2px solid #25b1f7;
        }
        .sports_top_right_title_right {
          cursor: pointer;
          display: inline-block;
          text-align: center;
          float: right;
          box-sizing: border-box;
          // padding-right: 19px;
          height: 59px;
          line-height: 59px;
          width: 111px;
          color: #999999;
        }
      }
      .sports_top_right_bottom {
        ul {
          padding: 0;
          list-style: none;
          li:hover{
            color: #25b1f7;
          }

          li {
            cursor: pointer;
            height: 55px;
            line-height: 55px;
            border-bottom: 1px dashed #e5e5e5;
            color: #666666;
            font-size: 16px;
            span{
              display: inline-block;
              width: 300px;
              overflow: hidden;
              text-overflow:ellipsis;
              white-space: nowrap;
            }
            em {
              float: right;
              font-style: normal;
              color: #999;
              font-size: 14px;
            }
          }
        }
      }
    }
  }
  .sports_bottom {
    margin-top: 30px;
    height: 572px;
    width: 100%;
    border: 1px solid rgba(229, 229, 229, 1);
    .sports_bottom_top {
      display: flex;
      border-bottom: 1px solid rgba(229, 229, 229, 1);
      height: 60px;
      .black{
        color: #333;
      }
      div {
        cursor: pointer;
        flex: 1;
        height: 100%;
        line-height: 60px;
        border-right: 1px solid rgba(229, 229, 229, 1);
        color: #999;
        text-align: center;
        i {
          color: #25b1f7;
          font-size: 22px;
          vertical-align: text-top;
        }
      }
      .lastDiv {
        border-right: none;
      }
    }
    .intro {
      width: 1198px;
      height: 511px;
      overflow: hidden;
      background: url("../assets/images/bg_intro.jpg");
      background-size: 100%;
      padding-left: 39px;
      padding-top: 35px;
      box-sizing: border-box;
      .intro_in{
        width: 787px;
        height: 385px;
        .textTop{
          box-sizing: border-box;
          padding: 5px;
          height: 195px;
          width: 100%;
          color: #666666;
          font-size: 16px;
          line-height: 32px;
          span{
            font-size: 48px;
            font-weight: 500;
          }
        }
        .img_big{
          margin-top: 56px;
          width: 100%;
          height: 134px;
          white-space:nowrap;
          // img{
          //   display: inline-block;
          // }
        }
      }
    }
   
  }
  .el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-col {
  border-radius: 4px;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
  margin-top: 25px;
  height: 120px;
  display: flex;
}
.row-bg {
  padding: 10px 0;
  // background-color: #f9fafc;
}
}

</style>



// WEBPACK FOOTER //
// src/pages/home.vue